import { call, put, takeLatest } from 'redux-saga/effects';
import { PatientsAPI } from '../../../api/patientsAPI';
import { ToastType } from '../../../utils/interfaces';
import {
  GET_PATIENT_HISTORY_ERROR,
  GET_PATIENT_HISTORY_REQUEST,
  GET_PATIENT_HISTORY_SUCCESS,
  SET_TOAST,
} from '../../actions';

function* workerGetPatientHistory(action: {
  type: string;
  payload: { patientPublicId: string };
}): Generator<any> {
  const { patientPublicId } = action.payload;

  try {
    const history: any = yield call(PatientsAPI.getPatientHistory, patientPublicId);
    if (!Array.isArray(history)) {
      throw new Error('Patient history response was not a list');
    }

    yield put({
      type: GET_PATIENT_HISTORY_SUCCESS,
      payload: { patientHistory: { [patientPublicId]: history } },
    });
  } catch (error: any) {
    yield put({
      type: GET_PATIENT_HISTORY_ERROR,
      payload: { code: error?.response?.status, message: error?.message },
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Couldn't load patient history",
        type: ToastType.ERROR,
      },
    });
  }
}

export function* watcherGetPatientHistory() {
  yield takeLatest(GET_PATIENT_HISTORY_REQUEST, workerGetPatientHistory);
}
